import {
  SET_FORM_SELECTORS,
  SET_TABLE_DATA,
  SET_IS_LOADING,
  SET_REPORT_KINDS,
  RESET_STATE,
} from '../constants/reportStatus';

const initialState = {
  reportKinds: [],
  tableData: [],
  isSelectedFilters: false,
  isLoading: false,
  formSelectors: {
    reportKindId: null,
    regionIds: [],
    localityIds: [],
    orgTypeIds: [],
    organizationIds: [],
    yearId: null,
  },
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_FORM_SELECTORS:
      return {
        ...state,
        formSelectors: action.payload,
        isSelectedFilters: true,
      };
    case SET_TABLE_DATA:
      return { ...state, tableData: action.payload };
    case SET_IS_LOADING:
      return { ...state, isLoading: action.payload };
    case SET_REPORT_KINDS:
      return { ...state, reportKinds: action.payload };
    case RESET_STATE:
      return {
        ...state,
        formSelectors: initialState.formSelectors,
        isSelectedFilters: false,
        tableData: [],
      };
    default:
      return state;
  }
}
